import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class UserGuard  {
  constructor(private authService: AuthService) { }
  canActivate(): boolean {
    return this.authService.isVendorAuthenticated()
  }
  
}
